import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";


const VideoCanvas = ({ videoSrc }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const ensurePlayback = () => {
      if (video.paused || video.readyState < 3) {
        video.play()
          .then(() => setIsPlaying(true))
          .catch((err) => console.warn("Autoplay prevented:", err));
      }
    };

    const handleCanPlay = () => ensurePlayback();
    const handleStalled = () => {
      console.warn("Video stalled, attempting restart...");
      video.load();
      ensurePlayback();
    };

    video.preload = "auto";
    video.addEventListener("canplay", handleCanPlay);
    video.addEventListener("stalled", handleStalled);

    ensurePlayback();

    return () => {
      video.removeEventListener("canplay", handleCanPlay);
      video.removeEventListener("stalled", handleStalled);
    };
  }, [videoSrc]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: isPlaying ? 1 : 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        pointerEvents: "none", // Prevent hover effects on other elements
      }}
    >
      <video
        ref={videoRef}
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          pointerEvents: "none",
        }}
      />
    </motion.div>
  );
};

export default VideoCanvas;
